// extracted by mini-css-extract-plugin
export default {"itemHolder":"AppTabContainerItemMobile_itemHolder__5q-Kc","itemHolderActive":"AppTabContainerItemMobile_itemHolderActive__MwtP-","title":"AppTabContainerItemMobile_title__IxGZh"};